import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useState } from "react";
import { TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import { BuyButton, UpSaleContainer } from "./upsellStyles";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const Uppertitle = styled.div`
  font: normal normal normal 30px "Helvetica Neue";
  margin-bottom: 10px;

  @media (max-width: ${TABLET_WIDTH}) {
    margin-top: 10px;
    font-size: 24px;
  }
`;
const Maintitle = styled.div`
  font: normal normal bold 58px "Helvetica Neue";
  color: rgb(1, 113, 0);
  text-align: center;

  padding-bottom: 15px;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 38px;
  }
`;
const Subtitle = styled.div`
  font: normal normal bold 23px "Helvetica Neue";

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 20px;
  }
`;

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15%;
  padding-right: 15%;
`;

const MiddleTitle = styled.div`
  font: normal normal bold 40px "Helvetica Neue";
  color: rgb(1, 113, 0);
  text-align: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;
const Middlecontent = styled.div`
  font: normal normal bold 28px "Helvetica Neue";
  text-align: center;
  * {
    font: normal normal bold 18px "Helvetica Neue";

    @media (max-width: ${TABLET_WIDTH}) {
      font-size: 16px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  font: normal normal normal 16px "Helvetica Neue";
  padding-left: 15%;
  padding-right: 15%;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 14px;
  }
`;

const BottomNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-left: 15%;
  padding-right: 15%;
`;

const Note = styled.div``;

const ActionDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border: 5px dashed #ff644e;
  padding: 40px;
  width: 80%;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ActionTitle = styled.div`
  font: normal normal bold 23px "Helvetica Neue";
  padding-bottom: 15px;
`;
const ActionContent = styled.div`
  font-size: 16px;
`;

const NotAdd = styled.div`
  text-align: center;
  cursor: pointer;
  color: #1f1e1e;
`;

interface Props {
  onBuy: () => void;
  onNoThanks: () => void;
  isModal?: boolean;
}

const Container = styled(UpSaleContainer)`
  border-radius: 100px;
  * {
    font-family: "Helvetica Neue", sans-serif !important;
  }
`;

export default function SubscriptionBiz(props: Props): JSX.Element {
  const { onBuy, onNoThanks, isModal } = props;
  const [loading, setLoading] = useState(false);

  return (
    <Container>
      <Header>
        <Uppertitle>How To Create Your Own Subscription Business</Uppertitle>
        <Maintitle>
          That Pays You
          <br /> Month After Month, <br />
          Year After Year, & <br />
          Decade After Decade…
          <br />
          For The Rest Of Your Life!
        </Maintitle>
      </Header>
      <Middle>
        <Subtitle>With this special one time offer called:</Subtitle>

        <MiddleTitle>“Subscription Biz”</MiddleTitle>
        <Middlecontent>
          <p>
            This 15+ hour audio-based training could go for thousands of
            dollars.
            <br />
            But if you add it to your order below <u>BEFORE</u> leaving this
            page
            <br /> you can have it delivered right to your smart phone for just:
          </p>
          $91
          <p>
            <u>NOTE: You MUST have a smart phone to use this product</u>
          </p>
        </Middlecontent>
      </Middle>
      <Content>
        <p>
          If you’ve ever wanted an email-driven subscription business that
          brings you consistent recurring revenue month after month after month…
          for possibly years & decades into the future, then this new course by
          BerserkerMail cofounders Ben Settle & Troy Broussard reveals how they
          do it for their own 7-figure businesses.
        </p>
        <p>And why they think YOU can, too.</p>
        <p>
          This 15+ hour, audio-based course will show you how to build your own
          subscription business with print newsletters, membership sites,
          coaching programs, and/or software offers. It combines Ben Settle’s
          15+ years selling various subscription newsletter, membership site, &
          coaching offers (both for his own businesses and for clients when he
          was a freelance copywriter/consultant) and Troy Broussard’s 15+ years
          selling various subscription coaching, membership site, & software
          offers (as well as consulting his elite mastermind clients on how to
          do the same).
        </p>
      </Content>
      <BottomNote>
        <Note>
          <span style={{ backgroundColor: "#fff046", fontWeight: 600 }}>
            The methodologies go perfectly with your new BerserkerMail account,
            too.
          </span>
          <p>And, in fact, was in many ways designed for use with hit.</p>
          <span style={{ fontWeight: 600 }}>
            <u>
              <p style={{ fontSize: "24px", fontWeight: 800 }}>NOTE:</p>
              There are no refunds on Subscription Biz, and all sales are final.
              If you are at-all unsure you want it, please pass up on it and
              continue with your order:
            </u>
          </span>
        </Note>
        <p>Add it to your order below or continue to complete your checkout…</p>
      </BottomNote>
      <ActionDiv>
        <ActionTitle>Yeah! I'm ready Troy and Ben!</ActionTitle>
        <ActionContent>
          I understand that there are no refunds and that all sales are final. I
          also understand that this training is only available within the mobile
          app.
        </ActionContent>
        <BuyButton
          onClick={() => {
            setLoading(true);
            onBuy();
          }}
          isLoading={loading}
        >
          Buy now!
        </BuyButton>
        By clicking above, a total of $91 will be charged from your card.
      </ActionDiv>
      <NotAdd onClick={onNoThanks}>
        <b>
          <u>No thanks, please do not add this offer to my purchase.</u>
        </b>
      </NotAdd>
    </Container>
  );
}
